import { render, staticRenderFns } from "./ClubSaiquList.vue?vue&type=template&id=606375c0&scoped=true&"
import script from "./ClubSaiquList.vue?vue&type=script&lang=js&"
export * from "./ClubSaiquList.vue?vue&type=script&lang=js&"
import style0 from "./ClubSaiquList.vue?vue&type=style&index=0&id=606375c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606375c0",
  null
  
)

export default component.exports